import { render } from "./ArtistSidebar.vue?vue&type=template&id=155a4606"
import script from "./ArtistSidebar.vue?vue&type=script&lang=js"
export * from "./ArtistSidebar.vue?vue&type=script&lang=js"

import "./ArtistSidebar.vue?vue&type=style&index=0&id=155a4606&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__